import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import * as easycom from '../commands/easycom';
import { inject, nextTick, onMounted, ref } from 'vue';
import { channelKey } from '@/keys';
import { invokeKey } from '@drapejs/core';
import useContext from '@/composables/useContext';
import useMeta from '@/composables/useMeta';


export default /*#__PURE__*/_defineComponent({
  __name: 'EasycomReturn',
  setup(__props) {

const channel = inject(channelKey);

const invoke = inject(invokeKey);
const { route } = useContext();

const isMounted = ref(false);

useMeta();

onMounted(async () => {
  isMounted.value = true;
  const response = await invoke!(easycom.commands.getReturnToken, {
    url: window.location.href,
    order: route.query.order,
    delivery: route.query.delivery || ''
  });

  await nextTick();

  const languageCode = channel?.value?.locale?.split('-')?.[0] || 'en';  
  (window as any).Easycom.init({ drToken: response.token, languageCode });
});

return (_ctx: any,_cache: any) => {
  const _component_easycom_returns = _resolveComponent("easycom-returns")!

  return (isMounted.value)
    ? (_openBlock(), _createBlock(_component_easycom_returns, {
        key: 0,
        style: {"width":"100%","height":"620px"}
      }))
    : _createCommentVNode("", true)
}
}

})